export function CardList({ children, className = "", ...props }) {
    return (
        <div
            className={`flex min-w-0 w-full flex-col gap-3 ${className}`.trim()}
            {...props}
        >
            {children}
        </div>
    );
}

export function DividedList({ children, className = "", ...props }) {
    return (
        <div
            className={`min-w-0 w-full divide-y divide-slate-200 ${className}`.trim()}
            {...props}
        >
            {children}
        </div>
    );
}

export function DividedListItem({ children, className = "", as: Component = "article" }) {
    return <Component className={`py-6 ${className}`.trim()}>{children}</Component>;
}

export const CARD_ITEM_PADDING_CLASS = "p-4";
